import clsx from "clsx";
import React from "react";
import styles from "./Chip.module.scss";
import { BackgroundColor, classForBackground } from "../Backgrounds/background";

interface ChipProps {
  background: BackgroundColor;
  className?: string;
}

export const Chip: React.FC<React.PropsWithChildren<ChipProps>> = ({
  children,
  className,
  background
}) => {
  const bgClass = classForBackground(background);
  return (
    <div className={clsx(styles.chip, className, bgClass)}>{children}</div>
  );
};
